<template>
  <el-drawer
    ref="driverDetail"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="60%"
    withHeader="false"
    @open="openDetail"
  >
    <div slot="title" style="display: flex; align-items: center">
      <div>驾驶员-{{ info.name }}</div>
      <div class="tips_box"
        >注意：该模块信息用于上传至交通部门监管信息平台，请保持信息完整与正确性！</div
      >
    </div>
    <div style="padding: 0 0 10px 20px; color: #606266; font-size: 14px">
      <span>信息完整度：</span>
      <span>{{ info.completeRate ? info.completeRate + '%' : '' }}</span>
    </div>
    <div class="top_box">
      <div class="dian"></div>
      <div style="margin-right: 20px"
        >{{ info.auditState === 1 ? '待审核' : info.auditState === 2 ? '审核通过' : '拒绝' }}
      </div>
      <div v-if="info.auditState === 1">
        <el-button size="small" type="primary" @click="auditClick(2)" v-has-permi="['driver_audit']"
          >通过</el-button
        >
        <el-button size="small" type="danger" @click="auditClick(3)" v-has-permi="['driver_audit']"
          >不通过</el-button
        >
      </div>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="基础信息" name="first">
        <el-row :gutter="40">
          <el-col :span="12">
            <el-descriptions :column="1" style="margin-left: 40px">
              <el-descriptions-item label="归属供应商" prop="merchantName"
                >{{ info.merchantName }}
              </el-descriptions-item>
              <el-descriptions-item label="身份证号">{{ info.identityCard }}</el-descriptions-item>
              <el-descriptions-item label="身份证有效期起">{{
                info.idCardOn
              }}</el-descriptions-item>
              <el-descriptions-item label="身份证有效期止"
                ><span
                  :style="
                    idCardOff === 'expiringSoon'
                      ? 'color: #FF881B'
                      : idCardOff === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                  >{{ info.idCardOff }}</span
                >
                <span
                  style="margin-left: 10px"
                  :style="
                    idCardOff === 'expiringSoon'
                      ? 'color: #FF881B'
                      : idCardOff === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                  >{{
                    idCardOff === 'expiringSoon'
                      ? '即将过期'
                      : idCardOff === 'expire'
                      ? '已过期'
                      : ''
                  }}</span
                >
              </el-descriptions-item>
              <el-descriptions-item label="性别"
                >{{ info.sex === 1 ? '男' : info.sex === 2 ? '女' : '其他' }}
              </el-descriptions-item>
              <el-descriptions-item label="婚姻状况">{{ info.maritalStatus }}</el-descriptions-item>
              <el-descriptions-item label="身份证地址">{{ info.address }}</el-descriptions-item>
              <el-descriptions-item label="现住址">{{ info.contactAddress }}</el-descriptions-item>
              <el-descriptions-item label="紧急联系电话">{{
                info.emergencyContactPhone
              }}</el-descriptions-item>
              <el-descriptions-item label="教育程度">{{ info.educational }}</el-descriptions-item>
              <el-descriptions-item label="驾驶证号">{{ info.licenseid }} </el-descriptions-item>
              <el-descriptions-item label="驾驶证初领日期">{{
                info.licenseDate
              }}</el-descriptions-item>
              <el-descriptions-item label="驾驶证有效期止"
                ><span
                  :style="
                    licenseDuedate === 'expiringSoon'
                      ? 'color: #FF881B'
                      : licenseDuedate === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                  >{{ info.licenseDuedate }}</span
                >
                <span
                  style="margin-left: 10px"
                  :style="
                    licenseDuedate === 'expiringSoon'
                      ? 'color: #FF881B'
                      : licenseDuedate === 'expire'
                      ? 'color: #FA5151'
                      : ''
                  "
                  >{{
                    licenseDuedate === 'expiringSoon'
                      ? '即将过期'
                      : licenseDuedate === 'expire'
                      ? '已过期'
                      : ''
                  }}</span
                >
              </el-descriptions-item>
              <el-descriptions-item label="手机型号">{{ info.mobileMode }} </el-descriptions-item>
              <el-descriptions-item label="司机照片">
                <el-image
                  style="width: 100px; height: 100px"
                  :src="info.headImg"
                  :preview-src-list="previewList"
                >
                  <template slot="error">
                    <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                  </template>
                </el-image>
              </el-descriptions-item>
              <el-descriptions-item label="驾驶证">
                <div class="flex flex-col">
                  <span
                    :style="
                      licenseDuedate === 'expiringSoon'
                        ? 'color: #FF881B'
                        : licenseDuedate === 'expire'
                        ? 'color: #FA5151'
                        : ''
                    "
                    >{{
                      licenseDuedate === 'expiringSoon'
                        ? '证照即将过期，请及时办理更新'
                        : licenseDuedate === 'expire'
                        ? '证照已过期，请及时办理更新'
                        : ''
                    }}</span
                  >
                  <div class="flex">
                    <div class="img_box">
                      <el-image
                        style="width: 120px; height: 100px; margin-right: 20px"
                        :src="info.licensePhotoFront"
                        :preview-src-list="previewList"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <span>驾驶证（正页）</span>
                    </div>
                    <div class="img_box">
                      <el-image
                        style="width: 120px; height: 100px"
                        :src="info.licensePhotoSubpage"
                        :preview-src-list="previewList"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <span>驾驶证（副页）</span>
                    </div>
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="身份证">
                <div class="flex flex-col">
                  <span
                    :style="
                      idCardOff === 'expiringSoon'
                        ? 'color: #FF881B'
                        : idCardOff === 'expire'
                        ? 'color: #FA5151'
                        : ''
                    "
                    >{{
                      idCardOff === 'expiringSoon'
                        ? '证照即将过期，请及时办理更新'
                        : idCardOff === 'expire'
                        ? '证照已过期，请及时办理更新'
                        : ''
                    }}</span
                  >
                  <div class="flex">
                    <div class="img_box">
                      <el-image
                        style="width: 120px; height: 100px; margin-right: 20px"
                        :src="info.idcardPhotoPositive"
                        :preview-src-list="previewList"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <span>身份证（正面）</span>
                    </div>
                    <div class="img_box">
                      <el-image
                        style="width: 120px; height: 100px"
                        :src="info.idcardPhotoReverse"
                        :preview-src-list="previewList"
                      >
                        <template slot="error">
                          <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                        </template>
                      </el-image>
                      <span>身份证（背面）</span>
                    </div>
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
          <el-col :span="12">
            <el-descriptions :column="1">
              <el-descriptions-item label="手机号码">{{ info.mobilePhone }} </el-descriptions-item>
              <el-descriptions-item label="出生日期">{{ info.birthday }}</el-descriptions-item>
              <el-descriptions-item label="国籍">{{ info.nationality }} </el-descriptions-item>
              <el-descriptions-item label="民族">{{ info.nation }} </el-descriptions-item>
              <el-descriptions-item label="户口登记机关"
                >{{ info.driverCensus }}
              </el-descriptions-item>
              <el-descriptions-item label="紧急联系人"
                >{{ info.emergencyContact }}
              </el-descriptions-item>
              <el-descriptions-item label="紧急联系地址"
                >{{ info.emergencyContactAddress }}
              </el-descriptions-item>
              <el-descriptions-item label="外语能力">{{ info.language }} </el-descriptions-item>
              <el-descriptions-item label="准驾车型">{{ info.licenseType }} </el-descriptions-item>
              <el-descriptions-item label="驾驶证有效期起"
                >{{ info.licenseStartDate }}
              </el-descriptions-item>
              <el-descriptions-item label="司机注册城市">{{ info.areaName }} </el-descriptions-item>
              <el-descriptions-item label="手机运营商"
                >{{ info.mobileOperator }}
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="运营登记" name="second">
        <el-descriptions :column="1" style="margin-left: 40px">
          <el-descriptions-item label="运营类型"
            >{{
              info.operationType === 1 ? '道路运输' : info.operationType === 2 ? '网络预约' : ''
            }}
          </el-descriptions-item>
          <el-descriptions-item label="合同签署公司">{{
            info.contractCompany
          }}</el-descriptions-item>
          <el-descriptions-item label="驾驶员证发证机构">{{
            info.netCarissueOrganization
          }}</el-descriptions-item>
          <el-descriptions-item label="初次领取资格证日期">{{
            info.getNetCarProofDate
          }}</el-descriptions-item>
          <el-descriptions-item label="资格证发证日期">{{
            info.netCarissueDate
          }}</el-descriptions-item>
          <el-descriptions-item label="资格证有效起始日期">{{
            info.netCarproofOn
          }}</el-descriptions-item>
          <el-descriptions-item label="资格证有效截止日期"
            ><span
              :style="
                netCarproofOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : netCarproofOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{ info.netCarproofOff }}</span
            >
            <span
              style="margin-left: 10px"
              :style="
                netCarproofOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : netCarproofOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{
                netCarproofOff === 'expiringSoon'
                  ? '即将过期'
                  : netCarproofOff === 'expire'
                  ? '已过期'
                  : ''
              }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="驾驶员资格证号">{{
            info.netTaxiDriveLicenseid
          }}</el-descriptions-item>
          <el-descriptions-item label="合同有效期起">{{ info.contractOn }}</el-descriptions-item>
          <el-descriptions-item label="合同有效期止"
            ><span
              :style="
                contractOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : contractOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{ info.contractOff }}</span
            >
            <span
              style="margin-left: 10px"
              :style="
                contractOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : contractOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{
                contractOff === 'expiringSoon'
                  ? '即将过期'
                  : contractOff === 'expire'
                  ? '已过期'
                  : ''
              }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="报备日期">{{ info.reportDate }}</el-descriptions-item>
          <el-descriptions-item label="驾驶员证下次考核日期"
            ><span
              :style="
                carHailingLicenseOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : carHailingLicenseOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{ info.carHailingLicenseOff }}</span
            >
            <span
              style="margin-left: 10px"
              :style="
                carHailingLicenseOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : carHailingLicenseOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{
                carHailingLicenseOff === 'expiringSoon'
                  ? '即将过期'
                  : carHailingLicenseOff === 'expire'
                  ? '已过期'
                  : ''
              }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="网约车驾驶员证">
            <div class="flex flex-col">
              <span
                :style="
                  netCarproofOff === 'expiringSoon'
                    ? 'color: #FF881B'
                    : netCarproofOff === 'expire'
                    ? 'color: #FA5151'
                    : ''
                "
                >{{
                  netCarproofOff === 'expiringSoon'
                    ? '证照即将过期，请及时办理更新'
                    : netCarproofOff === 'expire'
                    ? '证照已过期，请及时办理更新'
                    : ''
                }}</span
              >
              <div class="flex">
                <div class="img_box">
                  <el-image
                    style="width: 120px; height: 100px; margin-right: 20px"
                    :src="info.netLicensePhotoFront"
                    :preview-src-list="previewList"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <span>网约车驾驶员证（信息页）</span>
                </div>
                <div class="img_box">
                  <el-image
                    style="width: 120px; height: 100px"
                    :src="info.netLicensePhotoSubpage"
                    :preview-src-list="previewList"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <span>网约车驾驶员（考核记录页）</span>
                </div>
              </div>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="驾驶员体检证明" v-if="Object.keys(info).length">
            <div class="flex flex-col flex-center">
              <div class="flex">
                <!-- <el-image
                  v-for="(item, index) in info.medicalCertificate.split(',')"
                  :key="index"
                  style="width: 120px; height: 100px"
                  :class="info.medicalCertificate.split(',').length > 1 ? 'margin-right-20' : ''"
                  :src="item"
                  :preview-src-list="previewList"
                >
                  <template slot="error">
                    <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                  </template>
                </el-image> -->
                <div v-for="(item, index) in info.medicalCertificate.split(',')" :key="index">
                  <el-image
                    v-if="isImage(item) || !item"
                    style="width: 120px; height: 100px"
                    :class="info.medicalCertificate.split(',').length > 1 ? 'margin-right-20' : ''"
                    :src="item"
                    :preview-src-list="[item]"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <div v-else class="font-12 color-999 box" @click="handleDownload(item)">
                    <i class="el-icon-document font-18"></i>
                    <span class="line-1 font-16">{{ getFileName(item) }}</span>
                  </div>
                </div>
              </div>
              <span class="font-12 margin-top-10">驾驶员体检证明</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="体检日期">{{
            info.medicalCertificateOn
          }}</el-descriptions-item>
          <el-descriptions-item label="体检有效期止">
            <span
              :style="
                medicalCertificateOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : medicalCertificateOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{ info.medicalCertificateOff }}</span
            >
            <span
              style="margin-left: 10px"
              :style="
                medicalCertificateOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : medicalCertificateOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{
                medicalCertificateOff === 'expiringSoon'
                  ? '即将过期'
                  : medicalCertificateOff === 'expire'
                  ? '已过期'
                  : ''
              }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="驾驶员毒检证明" v-if="Object.keys(info).length">
            <div class="flex flex-col flex-center">
              <div class="flex">
                <!-- <el-image
                  v-for="(item, index) in info.drugCertificate.split(',')"
                  :key="index"
                  style="width: 120px; height: 100px"
                  :class="info.drugCertificate.split(',').length > 1 ? 'margin-right-20' : ''"
                  :src="item"
                  :preview-src-list="previewList"
                >
                  <template slot="error">
                    <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                  </template>
                </el-image> -->
                <div v-for="(item, index) in info.drugCertificate.split(',')" :key="index">
                  <el-image
                    v-if="isImage(item) || !item"
                    style="width: 120px; height: 100px"
                    :class="info.drugCertificate.split(',').length > 1 ? 'margin-right-20' : ''"
                    :src="item"
                    :preview-src-list="[item]"
                  >
                    <template slot="error">
                      <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                    </template>
                  </el-image>
                  <div v-else class="font-12 color-999 box" @click="handleDownload(item)">
                    <i class="el-icon-document font-18"></i>
                    <span class="line-1 font-16">{{ getFileName(item) }}</span>
                  </div>
                </div>
              </div>
              <span class="font-12 margin-top-10">驾驶员毒检证明</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="毒检日期">{{ info.drugCertificateOn }}</el-descriptions-item>
          <el-descriptions-item label="毒检有效期止">
            <span
              :style="
                drugCertificateOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : drugCertificateOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{ info.drugCertificateOff }}</span
            >
            <span
              style="margin-left: 10px"
              :style="
                drugCertificateOff === 'expiringSoon'
                  ? 'color: #FF881B'
                  : drugCertificateOff === 'expire'
                  ? 'color: #FA5151'
                  : ''
              "
              >{{
                drugCertificateOff === 'expiringSoon'
                  ? '即将过期'
                  : drugCertificateOff === 'expire'
                  ? '已过期'
                  : ''
              }}</span
            >
          </el-descriptions-item>
          <el-descriptions-item label="交管12123截图" v-if="Object.keys(info).length">
            <div class="flex flex-col flex-center">
              <div class="flex">
                <el-image
                  v-for="(item, index) in info.trafficManagement.split(',')"
                  :key="index"
                  style="width: 120px; height: 100px"
                  :class="info.trafficManagement.split(',').length > 1 ? 'margin-right-20' : ''"
                  :src="item"
                  :preview-src-list="previewList"
                >
                  <template slot="error">
                    <div class="color-bg-f6 full flex-center color-999">暂未上传图片</div>
                  </template>
                </el-image>
              </div>
              <span class="font-12 margin-top-10">交管12123截图</span>
            </div>
          </el-descriptions-item>
        </el-descriptions>
      </el-tab-pane>
      <el-tab-pane label="操作日志" name="third">
        <div class="padding-x-10">
          <operation-log :list="logList" :maxHeight="logTableHeight" />
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-drawer>
</template>

<script>
  import { getDriverInfo, driverAudit } from '@/api/driver/driver-manage'
  import { getLog } from '@/api/common'
  import { to } from '@/util/util'
  import OperationLog from '@/components/log-info/list'
  export default {
    components: {
      OperationLog
    },
    data() {
      return {
        logTableHeight: window.innerHeight - 190,
        activeName: 'first',
        info: {},
        drawer: false,
        logList: [],
        previewList: [],
        carHailingLicenseOff: '',
        netCarproofOff: '',
        contractOff: '',
        idCardOff: '',
        licenseDuedate: '',
        medicalCertificate: '',
        drugCertificate: '',
        trafficManagement: '',
        medicalCertificateOff: '',
        drugCertificateOff: ''
      }
    },
    methods: {
      // 数据初始化
      init(row) {
        this.logList = []
        this.getDriverInfoDetails(row.id)
        this.getLogData(row.id)
      },
      /* 获取详情 */
      async getDriverInfoDetails(params) {
        this.$loading()
        const [err, res] = await to(getDriverInfo(params))
        this.$loading().close()
        if (err) {
          throw err
        }
        const { code, data } = res
        if (code === 0) {
          if (data.headImg) {
            this.previewList.push(data.headImg)
          }
          data.licensePhotoFront = ''
          data.licensePhotoSubpage = ''
          if (data.licensePhotoReverse) {
            const licensePhoto = data.licensePhotoReverse.split(',')
            this.previewList.push(...licensePhoto)
            data.licensePhotoFront = licensePhoto[0]
            data.licensePhotoSubpage = licensePhoto[1]
          }
          if (data.idcardPhotoPositive) {
            this.previewList.push(data.idcardPhotoPositive)
          }
          if (data.idcardPhotoReverse) {
            this.previewList.push(data.idcardPhotoReverse)
          }
          data.netLicensePhotoFront = ''
          data.netLicensePhotoSubpage = ''
          if (data.netLicensePhotoReverse) {
            const netLicensePhoto = data.netLicensePhotoReverse.split(',')
            this.previewList.push(...netLicensePhoto)
            data.netLicensePhotoFront = netLicensePhoto[0]
            data.netLicensePhotoSubpage = netLicensePhoto[1]
          }
          if (data.medicalCertificate) {
            const result = data.medicalCertificate.split(',')
            this.previewList.push(...result)
          } else {
            data.medicalCertificate = ''
          }
          if (data.drugCertificate) {
            const result = data.drugCertificate.split(',')
            this.previewList.push(...result)
          } else {
            data.drugCertificate = ''
          }
          if (data.trafficManagement) {
            const result = data.trafficManagement.split(',')
            this.previewList.push(...result)
          } else {
            data.trafficManagement = ''
          }
          this.info = data
          this.drawer = true

          if (this.info.carHailingLicenseOff)
            this.computedDete(this.info.carHailingLicenseOff, 'carHailingLicenseOff')
          if (this.info.netCarproofOff)
            this.computedDete(this.info.netCarproofOff, 'netCarproofOff')
          if (this.info.contractOff) this.computedDete(this.info.contractOff, 'contractOff')
          if (this.info.idCardOff) this.computedDete(this.info.idCardOff, 'idCardOff')
          if (this.info.licenseDuedate)
            this.computedDete(this.info.licenseDuedate, 'licenseDuedate')
          if (this.info.medicalCertificateOff) {
            this.computedDete(this.info.medicalCertificateOff, 'medicalCertificateOff')
          }
          if (this.info.drugCertificateOff) {
            this.computedDete(this.info.drugCertificateOff, 'drugCertificateOff')
          }
        }
      },
      async getLogData(id) {
        const { code, data } = await getLog({
          bizLinkId: id,
          type: 7
        })
        if (code === 0) {
          this.logList = data
        }
      },
      // 计算日期
      computedDete(str, type) {
        const date = new Date(str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6))
        const m = new Date().getMonth() + 1 + ''
        const d = new Date().getDate() + ''
        const year = new Date().getFullYear()
        const month = m.length === 1 ? '0' + m : m
        const day = d.length === 1 ? '0' + d : d
        const nowDate = new Date(year + '-' + month + '-' + day)

        if (date - nowDate <= 8.64e7 * 30 && date - nowDate >= 0) {
          this[type] = 'expiringSoon'
        } else if (date - nowDate < 0) {
          this[type] = 'expire'
        } else {
          this[type] = ''
        }
      },
      // 审核
      auditClick(auditState) {
        const params = {
          auditState,
          type: 2,
          id: this.info.id
        }
        if (auditState === 3) {
          this.$prompt('确定审核不通过吗？', '提示', {
            inputPlaceholder: '请输入不通过原因',
            inputErrorMessage: '请输入不通过原因',
            cancelButtonText: '稍后再看',
            confirmButtonText: '确定',
            inputType: 'textarea'
          })
            .then(({ value }) => {
              params.refuseReason = value
              this.handleDriverAudit(params)
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              })
            })
        } else {
          this.handleDriverAudit(params)
        }
      },
      async handleDriverAudit(params) {
        this.$loading()
        const { code } = await driverAudit(params)
        this.$loading().close()
        if (code === 0) {
          this.$message.success('操作成功')
          this.init(this.info)
        }
      },
      handleClose() {
        this.previewList = []
        this.activeName = 'first'
        this.info = {}
        this.drawer = false
        this.$emit('close')

        this.reportDate = ''
        this.netCarproofOff = ''
        this.contractOff = ''
        this.idCardOff = ''
        this.licenseDuedate = ''
      },
      isImage(file) {
        const reg = /\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif)/gi
        return reg.test(file)
      },
      // 下载  imgage图片blob类型下载
      handleDownload(file) {
        window.open(file)
      },
      getFileName(url) {
        if (!url) {
          return ''
        }
        const filePath = url.split('/')
        return filePath[filePath.length - 1].split('?')[0]
      }
    }
  }
</script>

<style lang="scss" scoped>
  .img_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    span {
      font-size: 12px;
    }
  }

  .tips_box {
    font-size: 12px;
    color: #f56c6c;
    margin-left: 20px;
  }

  .dian {
    height: 6px;
    width: 6px;
    border: 1px solid #909399;
    border-radius: 5px;
    background-color: #909399;
    margin-right: 5px;
  }

  .auditStateBox {
    font-size: 14px;
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .top_box {
    position: absolute;
    left: 70%;
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 14px;
    z-index: 99;
  }

  ::v-deep .el-drawer__body {
    overflow: hidden;
  }
  ::v-deep .el-tab-pane {
    height: calc(100vh - 160px);
    overflow-x: hidden;
  }
  .box {
    width: 120px;
    height: 100px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-right: 20px;
  }
  .line-1 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; // 控制多行的行数
    -webkit-box-orient: vertical;
  }
</style>
